import CmsModel from '@/models/Cms';

const GET_DESTINATION_SEARCH = 'GET_DESTINATION_SEARCH';

/**
 * 搜索城市
 */
async function getDestinationSearch(params) {
  const payload = await new CmsModel().getDestinationSearch(params);
  return {
    type: GET_DESTINATION_SEARCH,
    payload
  }
}

const ACTION_TYPES = {
  GET_DESTINATION_SEARCH,
};

const ACTION = {
  getDestinationSearch,
};

const DestinationSearch = {
  ACTION_TYPES,
  ACTION
}

export default DestinationSearch;